import { render, staticRenderFns } from "./InputTag.vue?vue&type=template&id=9308c73e&scoped=true&"
import script from "./InputTag.vue?vue&type=script&lang=js&"
export * from "./InputTag.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/input-tag.scss?vue&type=style&index=0&id=9308c73e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9308c73e",
  null
  
)

export default component.exports